module.exports = "/virtual-football-league/img/amblems/left/logos/SwanCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/SwanCity.png
// module id = 2127
// module chunks = 4